import React from 'react';
import { useTranslation } from '../../contexts/TranslationContext';
import { ClassifierRow } from '../../utils/matchAnalysis';

interface ClassifierChartProps {
  rows: ClassifierRow[];
  ensemble: ClassifierRow;
  homeAbbr: string;
  awayAbbr: string;
}

const ClassifierChart: React.FC<ClassifierChartProps> = ({ rows, ensemble, homeAbbr, awayAbbr }) => {
  const { t } = useTranslation();
  const d = t.matchDashboard;
  const all = [...rows, ensemble];
  const scale = Math.ceil(Math.max(...all.map((r) => r.total), 1));

  const renderRow = (r: ClassifierRow, isEnsemble = false) => (
    <div key={r.name} className={`classifier-chart__row${isEnsemble ? ' classifier-chart__row--ensemble' : ''}`}>
      <span className="classifier-chart__name">{r.name}</span>
      <span className="classifier-chart__track">
        <span className="classifier-chart__bar" style={{ width: `${(r.total / scale) * 100}%` }} />
      </span>
      <span className="classifier-chart__value">{r.total.toFixed(2)}</span>
      <span className="classifier-chart__split">
        {r.home.toFixed(1)} : {r.away.toFixed(1)}
      </span>
    </div>
  );

  return (
    <div className="dash-card dash-card--wide">
      <div className="dash-card__head">
        <h3 className="dash-card__title">{d.classifiers}</h3>
        <span className="dash-card__caption">{d.classifiersCaption}</span>
      </div>
      <div className="classifier-chart">
        <div className="classifier-chart__row classifier-chart__row--head">
          <span />
          <span className="classifier-chart__scale">
            {Array.from({ length: scale + 1 }, (_, i) => (
              <span key={i}>{i}</span>
            ))}
          </span>
          <span className="classifier-chart__value">{d.total}</span>
          <span className="classifier-chart__split">
            {homeAbbr} : {awayAbbr}
          </span>
        </div>
        {rows.map((r) => renderRow(r))}
        {renderRow(ensemble, true)}
      </div>
    </div>
  );
};

export default ClassifierChart;
